import React from "react";
import "./styles.scss";

const ContentBox = ({ children, className = "" }) => {
  return (
    <div className={`content-box content-box--${className}`}>{children}</div>
  );
};

export default ContentBox;
